import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Service } from 'src/app/entities/service';
import { ServiceService } from 'src/app/services/service.service';
import { AuthService } from 'src/app/services/auth.service';
import { NavigationStart, Event as NavigationEvent, Router } from '@angular/router';
import { SharedService } from 'src/app/services/sharedService';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/services/user.service';
import { NotificationService } from 'src/app/services/notification.service';
import {ControlTeamService} from '../../../services/controlTeam.service';
import {ProcessService} from '../../../services/process.service';

@Component({
  selector: 'app-control-module-nav-header',
  templateUrl: './control-module-header.component.html',
  styleUrls: ['./control-module-header.component.css']
})

export class ControlModuleHeaderComponent implements OnInit, OnDestroy {
  mobileMenuOpen = false;
  controlTypesExpanded = false;
  leftMenuItems = [];
  leftMenuSubscription: any;
  @Input() contextMenu: string[];
  lang: string;
  username: string;
  initials: string;
  menuItems: string[][];
  notifications: any[];
  dropDownNotifications: any[];
  teams: any[];
  controlTypes: any[];
  user;
  services: Service[];
  loginSubscription: any;
  unseenNotifications = 0;
  teamName: any;
  controlTypeName: any;
  controlTypeNameShort: any;
  currentTeamId: any;
  currentControlType: any;
  constructor(private translate: TranslateService, private serviceService: ServiceService,
              private userService: UserService, private controlTeamService: ControlTeamService,
              public auth: AuthService, private router: Router, private sharedService: SharedService,
              private processService: ProcessService,
              private notificationService: NotificationService) {
    this.auth.loggedIn.subscribe(val => {
      if (val) {
        this.loadData();
      }
    });
  }

  loadData() {
        this.userService.getCurrentUser().subscribe(user => {
          if (user !== null) {
            this.user = user;
            this.getServices();
            this.controlTeamService.getMyControlTeams().subscribe(teams => {
              this.teams = teams;
              this.currentTeamId = localStorage.getItem('currentTeamId');
              if (this.currentTeamId) {
                const currentTeamEl = this.teams.find(elem => elem.id === this.currentTeamId);
                if (currentTeamEl) {
                  this.teamName = currentTeamEl.name;
                }
              } else if (this.teams.length > 0) {
                this.teamName = this.teams[0].name;
                localStorage.setItem('currentTeamId', this.teams[0].id);
                localStorage.setItem('currentTeamName', this.teamName);
                this.sharedService.changeTeam(this.teams[0].id);
              }
    
              this.processService.getControlTypeList('').subscribe(res => {
                this.controlTypes = [{key: null, name: 'ALL'}, ...res];
                this.currentControlType = localStorage.getItem('currentControlType');
                if (this.currentControlType) {
                
                  const currentControlTypeEl = this.controlTypes.find(elem => elem.key === this.currentControlType);
                  if (currentControlTypeEl) {
                    this.controlTypeName = currentControlTypeEl.name;
                  }
                } else {
                  this.controlTypeName = this.controlTypes[0].name;
                  let key =  this.controlTypes[0].key || ''
                  localStorage.setItem('currentControlType', key);
                  localStorage.setItem('currentControlTypeName', this.controlTypeName);
                  this.sharedService.changeControlType(key);
                }
                this.updateControlTypeShortName()
              });
    
            });
          }
        });
  }

  ngOnInit() {
    this.translate.setDefaultLang('en');
    this.setLang(localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en');
   
       
   

    this.leftMenuSubscription = this.sharedService.menuItemsEmitter.subscribe(menuItems => {
      this.setupMenu(menuItems);
    });

    this.getUnseenNotifications();
    // Poll only while the tab is visible; an inactive tab makes no requests.
    // Cleared on destroy — this header is recreated when entering the module,
    // and the old uncleared interval kept polling forever.
    this.unseenTimer = setInterval(() => {
      if (!document.hidden) { this.getUnseenNotifications(); }
    }, 60000);
    // Returning to the tab refreshes immediately instead of waiting a tick.
    document.addEventListener('visibilitychange', this.onVisibilityChange);


    this.router.events
      .subscribe(
        (event: NavigationEvent) => {
          if (event instanceof NavigationStart) {
          }
        });
  }

  toggleMobileMenu() { this.mobileMenuOpen = !this.mobileMenuOpen; }
  closeMobileMenu() { this.mobileMenuOpen = false; }

  setSeenAll() {
    this.unseenNotifications = 0;

    this.notificationService.setSeenAll().subscribe(result => {
      this.notificationService.getNotificationList().subscribe(res => {
        this.dropDownNotifications = res;
       });
    });
  }

  getServices() {
    this.serviceService.getTotalServiceList('').subscribe(services => {
      this.services = services;
    });
  }

  logout() {
    this.username = '';
    this.auth.logout().subscribe(res => {
      this.router.navigate(['login']);
      this.auth.setLoginStatus(false);
    });

  }

  userAccount() {
    this.router.navigate(['user', this.user.id]);
  }

  setupMenu(menuItems) {
    if (menuItems !== 'services') {
      this.leftMenuItems = menuItems;
    } else {
      this.serviceService.getTotalServiceList('').subscribe(services => {
        this.leftMenuItems = [];
        services.forEach(service => {
          this.leftMenuItems.push({ title: service.name, link: '/csv-list/' + service.id });
        });
      });
    }
  }

  ngOnDestroy() {
    clearInterval(this.unseenTimer);
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
    if (this.leftMenuSubscription) { this.leftMenuSubscription.unsubscribe(); }
  }

  private unseenTimer: any;
  private onVisibilityChange = () => {
    if (!document.hidden) { this.getUnseenNotifications(); }
  };

  setLang(lang) {
    this.sharedService.setLan(lang);
    this.lang = lang;
    this.translate.use(lang);
  }

  navigateToNotifications() {
    this.router.navigate(['notifications']);
  }
  navigateToNotification(value) {
    const route = value.referenceObject ? '/process/' + value.referenceObject.id + '/' + value.referenceObject.key : 'notifications';
    this.router.navigate([route]);
  }


  getUnseenNotifications() {
    this.notificationService.getUnseenCount().subscribe(count => {
      this.unseenNotifications = count['count'];
    });
  }

  onChange(event) {
    this.teamName = this.teams.find(elem => elem.id === event).name;
    localStorage.setItem('currentTeamId', event);
    localStorage.setItem('currentTeamName', this.teamName);
    this.sharedService.changeTeam(event);
  }

  onChangeType(event) {
    if (!event) event = ''
    let controlType = this.controlTypes.find(elem =>
        (event === '' && elem.key === null) ||  elem.key === event)
    this.controlTypeName = controlType.name;
    this.updateControlTypeShortName()
    localStorage.setItem('currentControlType', event);
    localStorage.setItem('currentControlTypeName', this.controlTypeName);
    this.sharedService.changeControlType(event);
  }

  updateControlTypeShortName(){
      this.controlTypeNameShort = this.controlTypeName.split(":")[0]
  }
}
